<h3-object-list-item
  *ngFor="let objectItem of objectItems$ | async"
  [objectItem]="objectItem"
  [class.reorder-before]="
    dragAndDropService.willReorderBefore$(objectItem.index) | async
  "
  [class.reorder-after]="
    dragAndDropService.willReorderAfter$(objectItem.index) | async
  "
  matRipple
  cdkDrag
  cdkDragPreviewContainer="parent"
  [cdkDragData]="objectItem"
  [cdkDragDisabled]="isDragDisabled"
  (cdkDragStarted)="dragStart($event)"
  (cdkDragReleased)="dragReleased()"
  [hidden]="isObjectDragged$(objectItem.index) | async"
>
  <ng-template cdkDragPreview [matchSize]="true">
    <div>
      <h3-object-list-item
        class="object-drag-preview"
        [class.droppable]="draggedItemCanBeDropped$ | async"
        [objectItem]="objectItem"
        [matBadge]="selectedObjectCount$ | async"
        [matBadgeHidden]="(selectedObjectCount$ | async)! <= 1"
        matBadgePosition="before"
      >
      </h3-object-list-item>
    </div>
  </ng-template>
</h3-object-list-item>
